import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import { appBar, filters, primaryColor } from '../Styles'
import ForecastEntry from '../components/ForecastEntry'

const ForecastsScreen = props => {
  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Previsiones</Typography>
          </div>
        </Toolbar>
      )}>
      <div className={props.classes.filters}>
        <Grid item container>
          <Grid xs={12} item onClick={props.openForecastsModal}>
            <Typography className={props.classes.filterName}>
              Fecha
              <KeyboardArrowDownIcon className={props.classes.icon} />
            </Typography>
            <Typography
              className={props.classes.filterValue}
              dangerouslySetInnerHTML={{ __html: props.forecastsPeriodLabel }}
            />
          </Grid>

        </Grid>
      </div>
      <Grid container>
        <Grid
          xs={12}
          onClick={() => {
            props.resetForecastData()
            props.onCreateForecast()
          }}
        >
          <div style={{ padding: '20px 30px', background: '#baccda' }}>
            <Button color="secondary" variant="raised" className={props.classes.createForecastButton}>
              Crear previsión
              <AddIcon className={props.classes.icon} />
            </Button>
          </div>
        </Grid>
        {props.forecasts && props.forecasts.forecasts.length ? (
          props.forecasts.forecasts.map((data, index) => {
            return (
              <ForecastEntry
                data={data}
                key={'fce' + index + data.productIconFileName + data.forecasts.length}
                onSelectForecast={props.onSelectForecast}
                {...props}
              />
            )
          })
        ) : (
          <Grid xs={12}>
            <div className={props.classes.noForecasts}>
              <span>No hay previsiones para este período</span>
            </div>
          </Grid>
        )}
      </Grid>
    </Page>
  )
}

const styles = {
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  main: {
    padding: 15,
  },
  head: {
    fontSize: 18,
    fontWeight: 600,
    paddingBottom: 15,
  },
  headNoPaddingBottom: {
    fontSize: 18,
    fontWeight: 600,
  },
  preference: {
    padding: 10,
    border: '1px solid #DDD',
    marginBottom: 10,
    cursor: 'pointer',
  },
  preferenceLabel: {
    fontSize: 15,
  },
  preferenceBody: {
    marginTop: -5,
    paddingBottom: 10,
  },
  preferenceInfo: {
    fontSize: 11,
    marginTop: 5,
  },
  select: {
    fontSize: 15,
    width: '100%',
  },
  filters,
  filterPeriod1: {
    padding: '5px 0',
    background: primaryColor,
  },
  filterPeriod2: {
    padding: '5px 0',
    background: '#8ACA4C',
  },
  icon: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
  filterName: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 300,
    fontSize: 13,
  },
  filterValue: {
    marginTop: -3,
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
  },
  createForecastButton: {
    width: '95%',
  },
  noForecasts: {
    margin: 20,
    fontSize: 20,
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

export default withStyles(styles)(ForecastsScreen)



// WEBPACK FOOTER //
// ./src/screens/ForecastsScreen.js